import { SelectOption } from "../../../interfaces";
import { InputType, RangeBarProps } from "../input-form";

export enum TvmFieldType {
	INPUT = "INPUT",
	SELECT = "SELECT",
}

export interface TvmFormFieldDefinition {
	type: TvmFieldType;
	inputType?: InputType;
	label: string;
	name?: string;
	selectOptions?: Array<SelectOption>;
	range?: RangeBarProps;
	index?: number;
	value?: any;
}

export interface HintsDef {
	title?: string;
	htmlDef: string;
}

export interface TvmFormDefinition {
	hints?: HintsDef;
	fields: {
		[key: string]: TvmFormFieldDefinition;
	};
	formula: {
		[key: string]: string;
	};
	flags?: {
		[key: string]: {
			defValue: boolean;
			expression: string;
		};
	};
}

export interface TvmFormSubmitResult<T> {
	_evaluationResult: T;
	_flags: { [key: string]: boolean };
}

export enum CellType {
	EXPRESSION = "EXPRESSION",
	VALUE = "VALUE",
}
